import type { ReminderSettings } from '@/core/domain';
import type { ReminderSettingsRepository } from '../repositories/reminder-settings-repository';

export class GetReminderSettingsByUserIdUseCase {
  constructor(private readonly repository: ReminderSettingsRepository) {}

  async execute(userId: string): Promise<ReminderSettings | null> {
    return this.repository.getById(userId);
  }
}
